import(/* webpackMode: "eager" */ "/app/apps/backoffice/app/(public)/page.tsx");
